import { render, staticRenderFns } from "./AppPayResultDialog.vue?vue&type=template&id=4f36e5c4&scoped=true&"
import script from "./AppPayResultDialog.vue?vue&type=script&lang=js&"
export * from "./AppPayResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppPayResultDialog.vue?vue&type=style&index=0&id=4f36e5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36e5c4",
  null
  
)

export default component.exports